<script>
import icon_home_on from "@/assets/img/icon_首页1_on@2x.png"
import icon_home_off from "@/assets/img/icon_首页1_off@2x.png"
import icon_my_on from "@/assets/img/icon_我的1_on@2x.png"
import icon_my_off from "@/assets/img/icon_我的1_off@2x.png"
export default {
	props: {
		title: {
			type: String,
			default: "untitled"
		},
		group: {
			type: String,
			default: ""
		}
	},
	data (){
		return {
			active: "/",
			tabs: [
				{
					label: "报名选课",
					name: "/courseHome",
					icon_on: icon_home_on,
					icon_off: icon_home_off
				},
				{
					label: "已选班级",
					name: "/courseHistory",
					icon_on: icon_home_on,
					icon_off: icon_home_off
				},
				{
					label: "我的",
					name: "/mine",
					icon_on: icon_my_on,
					icon_off: icon_my_off
				}
			]
		}
	},
	mounted (){
		this.$watch("group", nval=>{
			this.active = nval
		}, {
			immediate: true
		})
	},
	methods: {
		handleTabChange (name){
			this.$router.push(name).catch(e=>e)
		},
		getTabIcon (tab){
			if(tab.name === this.active){
				return tab.icon_on
			}
			return tab.icon_off
		}
	}
}
</script>
<template lang="pug">
.app-page(v-on="$listeners")
	.container
		slot
	.footer
		//van-tabbar(v-model="active" @change="handleTabChange" style="box-shadow: 1px 1px 7px #ccc ;")
			//van-tabbar-item(:icon="getTabIcon(tab)" :name="tab.name" v-for="tab in tabs" :key="tab.label") {{tab.label}}
			//- van-tabbar-item(icon="wap-home" name="/home") 首页
			//- van-tabbar-item(icon="manager" name="/my") 我的
</template>
<style lang="scss" scoped>
::v-deep .van-tabbar-item{
	.van-tabbar-item__text{
		color:#999;
	}
	&.van-tabbar-item--active{
		.van-tabbar-item__text{
			color:#f35252;
		}
	}
}
</style>